import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'siteco',
} as IModuleProps;
